import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/quote.constant";

export {
    addQuotes,
    updateSingleQuote,
    getSingleQuote,
    getSingleQuoteById,
    searchQuotes,
    searchQuotesWithSearchCriteria,
    prepareQuotesList
}

const collectionName = 'quotes';
const collectionReference = collection(fireStoreDB, collectionName);

const addQuotes = (quotes) => {
    return Promise.map(quotes, async quote => {
        await addSingleQuote(quote);
    });
}

const addSingleQuote = (quote) => {
    quote.createdAt = new Date();
    quote.updatedAt = quote.createdAt;
    return addDoc(collectionReference, quote);
}

const updateSingleQuote = (quote) => {
    const documentReference = doc(fireStoreDB, collectionName, quote.id);
    quote.updatedAt = new Date();
    return setDoc(documentReference, quote);
}

const getSingleQuote = (quoteId) => {
    const documentReference = doc(fireStoreDB, collectionName, quoteId);
    return getDoc(documentReference);
}

const getSingleQuoteById = async (quoteId) => {
    const documentReference = doc(fireStoreDB, collectionName, quoteId);
    const quoteResult = await getDoc(documentReference);
    return prepareQuoteData(quoteResult);
}

const searchQuotes = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const quoteResult = await getDocs(searchQuery);
    return prepareQuotesList(quoteResult);
}

const searchQuotesWithSearchCriteria = async (searchCriteriaList) => {
    let searchQuery = query(collectionReference);

    // console.log('searchQuotesWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    searchQuery = query(searchQuery, limit(DATA_LIMIT));

    const quoteResult = await getDocs(searchQuery);
    return prepareQuotesList(quoteResult);
}

const prepareQuotesList = (quoteResult) => {
    const quotesList = [];

    _.forEach(quoteResult.docs, quoteDoc => {
        quotesList.push({
            ...quoteDoc.data(),
            id: quoteDoc.id
        });
    });

    return quotesList;
}

const prepareQuoteData = (quoteDoc) => {
    if (!quoteDoc.exists) {
        return null;
    }

    return {
        ...quoteDoc.data(),
        id: quoteDoc.id
    }
}
